import React, { useMemo, memo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/About.css";
import profileImg from "../assets/profile.png";
import useScrollAnimation from "../hooks/useScrollAnimation";

const About = memo(function About() {
  const [titleRef, animate] = useScrollAnimation();

  const title = "About Me";

  const animatedTitle = useMemo(
    () =>
      title.split("").map((char, i) => (
        <span
          key={i}
          style={{ animationDelay: `${i * 0.08}s` }}
          className="animated-char"
        >
          {char === " " ? "\u00A0" : char}
        </span>
      )),
    [title]
  );

  return (
    <section id="about" className="about-section">
      <h2 ref={titleRef} className={`animated-title ${animate ? "show" : ""}`}>
        {animatedTitle}
      </h2>

      <Container className="about-container">
        <Row className="about-box">
          <Col className="about-image" lg={4}>
            <img src={profileImg} alt="Profile" loading="lazy" />
          </Col>
          <Col className="about-info" lg={8}>
            <p>
              I am a Front-End Developer with expertise in React, Next.js, and TypeScript, passionate about crafting modern, responsive, and high-performance web applications. I focus on writing clean, maintainable code while delivering seamless and engaging user experiences. Skilled in translating creative ideas into elegant digital solutions, I enjoy exploring the latest web technologies to build impactful projects that combine both functionality and aesthetic design.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
});

export default About;
